import React from 'react';
import './MostViewedTrips.css';
import { formatNumber } from '../../utils/analyticsHelpers';

const MostViewedTrips = ({ trips = [] }) => {
    return (
        <section className='mostViewedTrips'>
            <div className='mostViewedTripsHeader'>
                <div>
                    <h2>Most Viewed Trips</h2>
                    <span>Trips getting the most attention</span>
                </div>

                {trips.length > 0 && <span className='mostViewedTripsCount'>Top {trips.length}</span>}
            </div>

            {trips.length === 0 ? (
                <div className='mostViewedTripsEmpty'>No trip views found for this period</div>
            ) : (
                <div className='mostViewedTripsTable'>
                    {/* Table Header */}
                    <div className='mostViewedTripsTableHeader'>
                        <span>#</span>
                        <span>Trip</span>
                        <span>Views</span>
                        <span>Paid</span>
                        <span>Conversion</span>
                    </div>

                    {/* Table Rows */}
                    {trips.map((trip, index) => (
                        <div className='mostViewedTripsTableRow' key={trip.tripId || index}>
                            <span className='tripRank'>{index + 1}</span>

                            <div className='tripInfo'>
                                <strong>{trip.tripTitle || 'Unknown Trip'}</strong>

                                {trip.destination && <small>{trip.destination}</small>}
                            </div>

                            <span className='tripMetric'>{formatNumber(trip.views)}</span>

                            <span className='tripMetric'>{formatNumber(trip.paidBookings)}</span>

                            <span className='tripConversion'>{Number(trip.conversion || 0).toFixed(2)}%</span>
                        </div>
                    ))}
                </div>
            )}
        </section>
    );
};

export default MostViewedTrips;
